import { render, staticRenderFns } from "./DiscardActiveCardChangesDialog.vue?vue&type=template&id=8e290a7e&scoped=true"
import script from "./DiscardActiveCardChangesDialog.vue?vue&type=script&lang=js"
export * from "./DiscardActiveCardChangesDialog.vue?vue&type=script&lang=js"
import style0 from "./DiscardActiveCardChangesDialog.vue?vue&type=style&index=0&id=8e290a7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e290a7e",
  null
  
)

export default component.exports